<template>
  <!-- A building that isn't there has no tabs to offer; its page says so instead -->
  <SecondaryNavigation v-if="!isMissing" :links="navPanelLinks" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { AppRouteNames } from '@tallo/investor/navigation';
import { useBuildingQuery } from '@tallo/investor/property';

import { NavPanelLink } from '../root/nav-panel/nav-panel-link.interface';
import SecondaryNavigation from '../root/nav-panel/secondary-navigation.vue';

const route = useRoute();
// Read from the route every time: moving from one building's page to another's keeps this component
const buildingId = computed(() => route.params.buildingId as string);
const { isMissing } = useBuildingQuery(() => buildingId.value);

const navPanelLinks = computed<NavPanelLink[]>(() => {
  const params = { buildingId: buildingId.value };

  return [
    { id: 'building-nav-units', title: 'Units', appRoute: AppRouteNames.INVESTOR_BUILDING_UNITS, params },
    {
      id: 'building-nav-details',
      title: 'Building details',
      appRoute: AppRouteNames.INVESTOR_BUILDING_DETAILS,
      params,
    },
    { id: 'building-nav-team', title: 'Team', appRoute: AppRouteNames.INVESTOR_BUILDING_TEAM, params },
  ];
});
</script>
